import { z } from 'zod';

export const AddressBase = z.object({
  line_1: z.string(),
  line_2: z.string(),
  city: z.string(),
  region: z.string(),
  zip: z.string(),
  country: z.string()
});

export const Base = z.object({
  ad_gym_trainer_group_id: z.string(),
  ad_gym_staff_group_id: z.string(),
  maps_url: z.string().url(),
  is_sessions_active: z.boolean(),
  address: AddressBase,
  booking_business: z.string().email(),
  location_name: z.string(),
  service_id: z.string(),
  tags: z.array(z.string()),
  mbo_location_id: z.string(),
  timezone_name: z.string(),
  location_id: z.string(),
  timezone: z.string(),
  country_code: z.string()
});

export type Type = z.infer<typeof Base>;
export type AddressType = z.infer<typeof AddressBase>;
